// Catalog key — actual widget types live in admin/pages/dashboard/widgets/registry.ts
export type WidgetType = string

export interface GridPosition {
  col: number
  row: number
  colSpan: number
  rowSpan: number
}

export type SubjectType = 'user' | 'team' | 'overall'
export type PeriodType = 'round' | 'month' | 'quarter' | 'year' | 'total'

export interface WidgetInstance {
  id: string
  type: WidgetType
  position: GridPosition
  settings: Record<string, unknown>
}

export interface Slide {
  id: string
  title?: string
  widgets: WidgetInstance[]
}

export const SLIDE_TITLE_MAX_LEN = 80

export interface Dashboard {
  slides: Slide[]
  rotation_ms?: number
}

export const GRID_COLS = 6
export const GRID_ROWS = 3
export const DEFAULT_ROTATION_MS = 10500

// Logical dashboard canvas (chrome included) — fixed at 1920×1080 and CSS-scaled to viewport.
export const CANVAS_WIDTH = 1920
export const CANVAS_HEIGHT = 1080

// Slide content area inside the chrome (1920 − 2×32 padding = 1856; matches `.content`'s 792px max-height).
export const SLIDE_CONTENT_WIDTH = 1856
export const SLIDE_CONTENT_HEIGHT = 792
